import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { KpiCard, SectionTitle } from "@/components/dashboard/widgets";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import AdminDigestsCard from "@/components/admin/AdminDigestsCard";
import AdminActionCentre from "@/components/admin/AdminActionCentre";

export default function Overview() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/overview").then(r => setData(r.data)); }, []);
  if (!data) return <div className="text-sm text-slate-500">Loading…</div>;
  const { kpis, series } = data;
  return (
    <div className="space-y-8">
      <SectionTitle title="Admin overview" subtitle="Real-time platform health and economics." />

      {/* iter90r — Action centre: surfaces stale contracts + unpaid invoices first thing */}
      <AdminActionCentre />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <KpiCard label="Leads (total)" value={kpis.leads_total.toLocaleString()} testid="admin-kpi-leads" />
        <KpiCard label="Active users" value={kpis.users_total.toLocaleString()} testid="admin-kpi-users" />
        <KpiCard label="Buyers" value={kpis.buyers} testid="admin-kpi-buyers" />
        <KpiCard label="Revenue (MTD)" value={kpis.revenue.toLocaleString()} prefix="£" testid="admin-kpi-rev" />
      </div>
      <Card className="rounded-xl shadow-soft border-slate-200">
        <CardContent className="p-5">
          <div className="flex items-center justify-between mb-3"><h3 className="font-medium text-slate-900">Platform volume</h3><span className="text-xs text-slate-500">Last 14 days</span></div>
          <ResponsiveContainer width="100%" height={288} minWidth={0} minHeight={200}>
            <LineChart data={series} margin={{ left: -8, right: 8, top: 8, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" vertical={false} />
              <XAxis dataKey="date" tick={{ fontSize: 11, fill: "#64748b" }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fontSize: 11, fill: "#64748b" }} axisLine={false} tickLine={false} />
              <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8, border: "1px solid #e2e8f0" }} />
              <Line dataKey="leads" stroke="#0055FF" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <AdminDigestsCard />
    </div>
  );
}
